var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageContainer',[_c('div',{staticClass:"page-container"},[_c('h1',[_vm._v("Help")]),_c('p',[_vm._v(" Please contact gauxx026@umn.edu for all inquires. Helping readers enjoy our site is out utmost concern. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }